/* unplugin-vue-components disabled */import { render } from "./NavBarMenu.vue?vue&type=template&id=181b5002"
const script = {}

import exportComponent from "/builds/eb-football/footy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__